<i18n>
{
  "fr": {
    "justification": "Justification",
    "justification-reason-placeholder": "Expliquez pourquoi cet indicateur n'est pas applicable.",
    "justification-reason-save": "Enregistrer",
    "error-justification-empty": "Veuillez sélectionner une justification"
  },
  "en": {
    "justification": "Justification",
    "justification-reason-placeholder": "Explain why this indicator is not applicable.",
    "justification-reason-save": "Save",
    "error-justification-empty": "Please select a justification"
  }
}
</i18n>
<template>
  <div class="justification-editor">
    <s-field
      :label="$t('justification')"
      custom-class="is-size-7 is-uppercase"
      :value="justification"
      :rules="rules.justification"
      validate-immediately
      validate-on-input
    >
      <b-select expanded :value="justification" @input="(v) => $emit('justification-changed', v)" :disabled="readOnly">
        <option v-for="i in justifications" :key="i.value" :value="i.value">{{ i.text }}</option>
      </b-select>
    </s-field>

    <s-field :value="tempReason" v-if="showReason">
      <b-input
        expanded
        type="textarea"
        :placeholder="$t('justification-reason-placeholder')"
        :custom-class="!tempReason ? 'is-danger' : ''"
        v-model="tempReason"
      />
    </s-field>
    <b-button v-if="reasonIsDirty" size="is-small" type="is-link" @click="$emit('reason-changed', tempReason)">
      {{ $t('justification-reason-save') }}
    </b-button>
  </div>
</template>

<script>
import { GeneralIndicatorGraphType, ProjectIndicatorGraphType } from '@/consts/graphql'
import {
  BUSINESS_CATEGORY_EEM,
  BUSINESS_CATEGORY_PROVIDER,
  IndicatorJustifications_General_EEM,
  IndicatorJustifications_General_FS,
  IndicatorJustifications_Project_EEM,
  IndicatorJustifications_Project_FS,
  INDICATOR_JUSTIFICATION_OTHER_REASON
} from '@/consts/enums'

import EnumHelper from '@/helpers/enums'
import FormHelper from '@/helpers/form'

import SField from '@/components/form/field'

export default {
  components: { SField },
  props: {
    justification: String,
    reason: String,
    indicatorGraphType: String,
    businessCategory: String,
    readOnly: Boolean
  },
  data() {
    return {
      tempReason: this.reason
    }
  },
  computed: {
    rules() {
      return {
        justification: [(value) => FormHelper.notEmpty(value) || this.$t('error-justification-empty')]
      }
    },
    showReason() {
      return this.justification === INDICATOR_JUSTIFICATION_OTHER_REASON
    },
    reasonIsDirty() {
      return this.tempReason !== this.reason
    },
    justifications() {
      let list = null

      if (this.indicatorGraphType === GeneralIndicatorGraphType) {
        if (this.businessCategory === BUSINESS_CATEGORY_EEM) {
          list = IndicatorJustifications_General_EEM
        } else if (this.businessCategory === BUSINESS_CATEGORY_PROVIDER) {
          list = IndicatorJustifications_General_FS
        }
      } else if (this.indicatorGraphType === ProjectIndicatorGraphType) {
        if (this.businessCategory === BUSINESS_CATEGORY_EEM) {
          list = IndicatorJustifications_Project_EEM
        } else if (this.businessCategory === BUSINESS_CATEGORY_PROVIDER) {
          list = IndicatorJustifications_Project_FS
        }
      }

      // Fallback
      if (!list) {
        list = [INDICATOR_JUSTIFICATION_OTHER_REASON]
      }

      return list.map((x) => {
        return {
          value: x,
          text: EnumHelper.formatIndicatorJustification(x),
          selected: this.justification === x
        }
      })
    }
  },
  watch: {
    reason(r) {
      this.tempReason = r
    }
  }
}
</script>

<style lang="scss" scoped>
.justification-editor {
  background-color: $grey-lightest;
  border-radius: $radius;
  margin-top: -0.5rem;
  padding: 0.75rem;
  position: relative;

  &::before {
    content: '';

    $arrow-size: 0.75rem;
    $arrow-offset: 0.5rem;

    position: absolute;
    top: -$arrow-size;
    left: $arrow-offset;

    border-left: $arrow-size solid transparent;
    border-right: $arrow-size solid transparent;
    border-bottom: $arrow-size solid $grey-lightest;
  }
}
</style>